export const APP_CONST = {
  DEFAULT_COLORS: {
    INTERACTIVE: '#0E57CC',
    FOCUS: '#B6CCEF'
  },
  FALLBACK_APP: 'claim-lookup',
  LAST_MFE_PATH: 'lastMfePath',
  MOBILE_THRESHOLD_WIDTH: 960,
  TERMS_AND_CONDITIONS_PATH: '/session/terms-and-conditions'
} as const;
